module.exports = __webpack_public_path__ + "static/intertec_screen_2-9b14f2991c571de784fdfcf1ac8b8b87.avif";